import axios from "axios";
import { toast } from "react-toastify";

let isUnauthorizedError = false;

const BASE_URL = process.env.REACT_APP_NEWHOSPITAL_BASEURL || '';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const clearSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  globalThis.location.href = "/";
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error || {};
    
    if (response?.status === 401 && !isUnauthorizedError) {
      isUnauthorizedError = true;
      
      toast.warn("Your session has ended. Please log in again to continue.", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          clearSession();
        }
      });
      
      setTimeout(() => {
        clearSession();
      }, 3000);
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;